import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { SapC4CResourceDataset } from 'app/model/dataset/sapc4c-resource.dataset';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapC4CResourceDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                path: '*'
            }
        }
    }
})
export class SapC4CResourceDatasetAdapter extends TabularTypeDatasetAdapter<SapC4CResourceDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SapC4CResourceDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SapC4CResourceDataset).name, 'path');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SapC4CResourceDataset): Promise<SapC4CResourceDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SapC4CResourceDataset.MODEL, 'path');
    }
}
